import { InjectionToken, Provider, Type } from '@angular/core';

import { DotCmsFallbackComponent } from '../dot-cms-fallback/dot-cms-fallback.component';

import { DotCmsBlockEditorBlockQuoteComponent } from './dot-cms-block-editor-block-quote/dot-cms-block-editor-block-quote.component';
import { DotCmsBlockEditorCodeBlockComponent } from './dot-cms-block-editor-code-block/dot-cms-block-editor-code-block.component';
import { DotCmsBlockEditorContentTypeComponent } from './dot-cms-block-editor-content-render/dot-cms-block-editor-content-render.component';
import { DotCmsBlockEditorHeadingComponent } from './dot-cms-block-editor-heading/dot-cms-block-editor-heading.component';
import { DotCmsBlockEditorHorizontalLineComponent } from './dot-cms-block-editor-horizontal-line/dot-cms-block-editor-horizontal-line.component';
import { DotCmsBlockEditorListOrderedComponent } from './dot-cms-block-editor-list-ordered/dot-cms-block-editor-list-ordered.component';
import { DotCmsBlockEditorListUnorderedComponent } from './dot-cms-block-editor-list-unordered/dot-cms-block-editor-list-unordered.component';
import { DotCmsBlockEditorParagraphComponent } from './dot-cms-block-editor-paragraph/dot-cms-block-editor-paragraph.component';
import { DotCmsBlockEditorTableComponent } from './dot-cms-block-editor-table/dot-cms-block-editor-table.component';
import { DotCmsBlockEditorVideoComponent } from './dot-cms-block-editor-video/dot-cms-block-editor-video.component';

export interface DotCmsBlockEditorComponentProvider {
  contentType: string;
  class: Type<DotCmsBlockEditorContentTypeComponent>;
}

export const DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT = new InjectionToken<DotCmsBlockEditorComponentProvider>(
  'DotCmsBlockEditorComponentProvider'
);

export const dotCmsBlockEditorContentTypeComponentProviders: Provider[] = [
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'heading',
      class: DotCmsBlockEditorHeadingComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'paragraph',
      class: DotCmsBlockEditorParagraphComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'orderedList',
      class: DotCmsBlockEditorListOrderedComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'bulletList',
      class: DotCmsBlockEditorListUnorderedComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'codeBlock',
      class: DotCmsBlockEditorCodeBlockComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'blockquote',
      class: DotCmsBlockEditorBlockQuoteComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'horizontalRule',
      class: DotCmsBlockEditorHorizontalLineComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'table',
      class: DotCmsBlockEditorTableComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'youtube',
      class: DotCmsBlockEditorVideoComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_BLOCK_EDITOR_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'fallbackNoComponent',
      class: DotCmsFallbackComponent,
    },
    multi: true,
  },
];
